import { Sparkles, Cpu, Layers, CalendarClock, Grid3X3 } from "lucide-react";
import { SectionHead } from "./SectionHead";
import { Reveal } from "./Reveal";
import { useSection } from "../../lib/content";

const ICONS = [Sparkles, Cpu, Layers, CalendarClock, Grid3X3];

export const WhyMove = () => {
  const c = useSection("whyMove");

  return (
    <section id="why-move" className="relative bg-white py-28 lg:py-36">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-6">
          <SectionHead chapter="02" eyebrow={c.eyebrow} title={c.title} lead={c.lead} />
        </div>
        <div className="lg:col-span-6 flex flex-col justify-center">
          <p className="font-mono text-xs uppercase tracking-[0.18em] font-semibold text-slate-500 mb-6">
            Gen 2 helps you
          </p>
          <div className="space-y-3">
            {c.benefits.map((text, i) => {
              const Icon = ICONS[i % ICONS.length];
              return (
                <Reveal key={text} delay={i * 0.08}>
                  <div className="group flex items-start gap-4 rounded-2xl border border-[#2a2a2a] bg-[#1a1a1a] p-5 transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1 hover:border-[#024AD8]/50 hover:shadow-[0_16px_40px_-16px_rgba(2,74,216,0.25)]">
                    <span className="shrink-0 w-10 h-10 rounded-xl bg-[#024AD8] text-white grid place-items-center transition-colors duration-300 group-hover:bg-[#FF5050]">
                      <Icon className="w-5 h-5" />
                    </span>
                    <p className="text-slate-300 text-sm sm:text-base leading-relaxed pt-2">{text}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
